/**

 Based off jquery.timeago, but simplified for our need, wrapped it in AMD, and removed the hard dependecy of jQuery.

 Andreas (January 2013): Fixed broken caching, use momentjs for date parsing and output

 * Timeago is a jQuery plugin that makes it easy to support automatically
 * updating fuzzy timestamps (e.g. "4 minutes ago" or "about 1 day ago").

 * Copyright (c) 2008-2012, Ryan McGeary (ryan -[at]- mcgeary [*dot*] org)

 * Modifed by Kenneth Auchenberg, October 2012, Podio

 */

define('lib/Podio.UI.Timestamps',['require','underscore','jquery','lib/Podio.Time','lib/Podio.Event','lib/Podio.Utils','moment'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var podioTime = require('lib/Podio.Time');
  var podioEvent = require('lib/Podio.Event');
  var podioUtils = require('lib/Podio.Utils');
  var moment = require('moment');

  var timestamperInstance;

  var settings = {
    refreshRate: 30000
  };

  var Timestamper = function(elmCollection) {

    var self = this;

    this.elmCollection = elmCollection;

    // Update timestamps now
    this.renderCollection();

    // Start timer
    this.startTimer(elmCollection);

  };

  _.extend(Timestamper.prototype, {

    getDatetime: function(elmTarget) {
      return moment.min(
        podioTime.localMomentFromString($.trim(elmTarget.attr("datetime"))),
        podioTime.current()
      );
    },

    resolveTimestamp : function(elmTarget, index) {

      if (!elmTarget.data('autoupdatingTimestamp')) {
        elmTarget.data('autoupdatingTimestamp', this.getDatetime(elmTarget));
      }

      return elmTarget.data('autoupdatingTimestamp');
    },

    renderCollection: function() {
      var self = this;

      _.each(this.elmCollection, function(elmTarget, index) {
        elmTarget = $(elmTarget);
        var date = self.resolveTimestamp(elmTarget, index);

        if (!isNaN(date)) {
          var text = date.from(podioTime.current());
          elmTarget.text(text);
        }
      });

    },

    startTimer: function() {

      var self = this;

      this.timerInterval = setInterval(function() {
        self.renderCollection();
      }, settings.refreshRate);
    },

    endTimer: function() {
      clearInterval(this.timerInterval);
    }

  });


  function start() {
    // Initialize a timestamper on all <time datetime> elements
    timestamperInstance = new Timestamper($('time[datetime]'));
  }

  function stop() {
    timestamperInstance.endTimer();
  }

  function refresh() {
    if (timestamperInstance && timestamperInstance.timerInterval) {
      timestamperInstance.endTimer();
    }
    timestamperInstance = new Timestamper($('time[datetime]'));
  }

  function onInit() {
    start();
  }

  podioEvent.bind(podioEvent.Types.init, onInit);

  return {
    start: start,
    refresh: refresh,
    stop: stop
  };

});



